import { css } from '@emotion/react'

const content = css`
  max-width: 400px;
`

export const styles = {
  content,
}
